import React, { useEffect, useState } from "react";
import QRCode from "react-qr-code";
import AuthService from "services/auth.service";
import { FaBtc, FaArrowLeft, FaUpload, FaCheck, FaTimes } from "react-icons/fa";
import Btc from "../assets/img/digital/btc.svg";
import Eth from "../assets/img/digital/eth.svg";
import Usdt from "../assets/img/digital/usdt.svg";
import Usdc from "../assets/img/digital/usdc.svg";
import apple from "../assets/img/digital/apple.svg";
import ebay from "../assets/img/digital/ebay.svg";
import Sephora from "../assets/img/digital/sephora.svg";
import walmart from "../assets/img/digital/walmart.svg";

const DepositModal = ({ isOpen, onClose }) => {
  const [wallets, setWallets] = useState([]);
  const [selected, setSelected] = useState(null);
  const [copied, setCopied] = useState(false);
  const [view, setView] = useState("list"); // "list", "detail", or "upload"
  const [frontImage, setFrontImage] = useState(null);
  const [backImage, setBackImage] = useState(null);
  const [frontFile, setFrontFile] = useState(null);
  const [backFile, setBackFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");
  const [successful, setSuccessful] = useState(false);

  // Map currency names to their respective icons
  const currencyIcons = {
    BTC: Btc,
    ETH: Eth,
    USDT: Usdt,
    USDC: Usdc,
    APPLE: apple,
    EBAY: ebay,
    SEPHORA: Sephora,
    WALMART: walmart,
    OTHERS: null,
  };

  // Gift card options - all will use upload form
  const giftCardOptions = [
    { id: "apple", name: "Apple", type: "giftcard" },
    { id: "ebay", name: "eBay", type: "giftcard" },
    { id: "sephora", name: "Sephora", type: "giftcard" },
    { id: "walmart", name: "Walmart", type: "giftcard" },
    { id: "others", name: "Others", type: "giftcard" },
  ];

  useEffect(() => {
    if (!isOpen) return;
    AuthService.getWallets()
      .then((res) => setWallets(res.data.filter(w => w.enabled !== false)))
      .catch(() => setWallets([]));
  }, [isOpen]);

  // Reset view when modal closes
  useEffect(() => {
    if (!isOpen) {
      setView("list");
      setSelected(null);
      setFrontImage(null);
      setBackImage(null);
      setFrontFile(null);
      setBackFile(null);
      setUploading(false);
      setMessage("");
      setSuccessful(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleCopy = async () => {
    if (!selected) return;
    try {
      await navigator.clipboard.writeText(selected.address);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (_) {}
  };

  const handleSelectWallet = (wallet) => {
    setSelected(wallet);
    setView("detail");
  };

  const handleSelectGiftCard = (giftcard) => {
    setSelected(giftcard);
    setView("upload");
  };

  const handleBack = () => {
    setView("list");
    setSelected(null);
    setFrontImage(null);
    setBackImage(null);
    setFrontFile(null);
    setBackFile(null);
    setMessage("");
    setSuccessful(false);
  };

  // Get the appropriate icon based on wallet name
  const getWalletIcon = (walletName) => {
    const upperName = walletName.toUpperCase();
    for (const [key, icon] of Object.entries(currencyIcons)) {
      if (upperName.includes(key)) {
        return icon;
      }
    }
    return null;
  };

  const handleImageUpload = (e, type) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type
      if (!file.type.startsWith('image/')) {
        setMessage("Please select an image file");
        setSuccessful(false);
        return;
      }

      // Validate file size (5MB)
      if (file.size > 5 * 1024 * 1024) {
        setMessage("File size must be less than 5MB");
        setSuccessful(false);
        return;
      }

      const reader = new FileReader();
      reader.onload = (event) => {
        if (type === "front") {
          setFrontImage(event.target.result);
          setFrontFile(file);
        } else {
          setBackImage(event.target.result);
          setBackFile(file);
        }
        setMessage(""); // Clear any previous messages
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmitGiftCard = async () => {
    if (!frontFile || !backFile || !selected) return;

    setUploading(true);
    setMessage("");
    
    try {

          const currentUser = AuthService.getCurrentUser(); // Get current user data

           if (!currentUser || !currentUser.id) {
      setMessage("User not authenticated. Please log in again.");
      setSuccessful(false);
      setUploading(false);
      return;
    }



      const formData = new FormData();
      formData.append("frontImage", frontFile);
      formData.append("backImage", backFile);
      formData.append("cardType", selected.name);


       
    // Add user information to formData
    formData.append("userId", currentUser.id);
    formData.append("userEmail", currentUser.email);
    formData.append("userName", `${currentUser.firstName || ''} ${currentUser.lastName || ''}`.trim());

      const response = await AuthService.uploadCard(formData);
      setMessage("Gift card submitted successfully! Our team will review it shortly.");
      setSuccessful(true);
      
      // Reset form after successful upload
      setFrontImage(null);
      setBackImage(null);
      setFrontFile(null);
      setBackFile(null);
      
      setTimeout(() => {
        onClose();
      }, 3000);
      
    } catch (error) {
      const resMessage =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        "Error uploading gift card. Please try again.";
      setMessage(resMessage);
      setSuccessful(false);
    } finally {
      setUploading(false);
    }
  };

  const SelectedIcon = selected ? getWalletIcon(selected.name) : null;

  return (
    <div className="modal-backdrop" onClick={(e) => e.target.classList.contains("modal-backdrop") && onClose()}>
      <div className="modal-content" style={{ maxWidth: 640 }}>
        <button className="close-button" onClick={onClose}>
          ×
        </button>
        
        {view === "list" ? (
          <>
            <h3 style={{fontFamily: "DM Serif Display", marginBottom: 24}}>Add Money</h3>
            
            {/* Crypto Wallets */}
            <div>
              <h4 style={{ fontFamily: "sono", marginBottom: 12, color: "#374151" }}>Cryptocurrency</h4>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 24 }}>
                {wallets.map((w) => {
                  const WalletIcon = getWalletIcon(w.name);
                  return (
                    <button
                      key={w.id}
                      className={`quick-action-hold-single`}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        width: "100%",
                        fontFamily: "sono",
                        gap: 12,
                        padding: 12,
                        borderRadius: 8,
                        background: "#f8f9fb",
                        border: "1px solid #e5e7eb",
                        cursor: "pointer",
                        transition: "all 0.2s ease"
                      }}
                      onMouseOver={(e) => e.target.style.background = "#f1f5f9"}
                      onMouseOut={(e) => e.target.style.background = "#f8f9fb"}
                      onClick={() => handleSelectWallet(w)}
                    >
                      {WalletIcon ? (
                        <img src={WalletIcon} alt={w.name} width={22} height={22} style={{ borderRadius: 4 }} />
                      ) : w.icon ? (
                        <img src={w.icon} alt={w.name} width={22} height={22} style={{ borderRadius: 4 }} />
                      ) : (
                        <div style={{ width: 22, height: 22, borderRadius: 4, background: "#e5e7eb" }} />
                      )}
                      <span style={{ color: "#111827", fontWeight: 500 }}>{w.name}</span>
                    </button>
                  );
                })}
              </div>
            </div>

            {/* Gift Cards */}
            <div>
              <h4 style={{ fontFamily: "sono", marginBottom: 12, color: "#374151" }}>Gift Cards</h4>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                {giftCardOptions.map((giftcard) => {
                  const GiftCardIcon = getWalletIcon(giftcard.name);
                  return (
                    <button
                      key={giftcard.id}
                      className={`quick-action-hold-single`}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        width: "100%",
                        fontFamily: "sono",
                        gap: 12,
                        padding: 12,
                        borderRadius: 8,
                        background: "#f8f9fb",
                        border: "1px solid #e5e7eb",
                        cursor: "pointer",
                        transition: "all 0.2s ease"
                      }}
                      onMouseOver={(e) => e.target.style.background = "#f1f5f9"}
                      onMouseOut={(e) => e.target.style.background = "#f8f9fb"}
                      onClick={() => handleSelectGiftCard(giftcard)}
                    >
                      {GiftCardIcon ? (
                        <img src={GiftCardIcon} alt={giftcard.name} width={22} height={22} style={{ borderRadius: 4 }} />
                      ) : (
                        <div style={{ width: 22, height: 22, borderRadius: 4, background: "#e5e7eb" }} />
                      )}
                      <span style={{ color: "#111827", fontWeight: 500 }}>{giftcard.name}</span>
                    </button>
                  );
                })}
              </div>
            </div>
          </>
        ) : view === "detail" ? (
          // Crypto Deposit View
          <>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
              <button 
                className="back-button"
                onClick={handleBack}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontSize: 20,
                  color: "#6b7280",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  transition: "background-color 0.2s"
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = "#f3f4f6"}
                onMouseOut={(e) => e.target.style.backgroundColor = "transparent"}
              >
                <FaArrowLeft />
              </button>
              <h3 style={{ margin: 0, fontFamily: "DM Serif Display" }}>Deposit {selected?.name}</h3>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", background: "#fff", padding: 16, borderRadius: 8, border: "1px solid #e5e7eb" }}>
                <QRCode value={selected?.address || ""} size={164} />
              </div>
              <div>
                <div style={{ marginBottom: 16 }}>
                  <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>Wallet - network</div>
                  <div style={{ fontWeight: 600, fontSize: 16 }}>{selected?.name}{selected?.network ? ` · ${selected.network}` : ""}</div>
                </div>
                <div style={{ marginBottom: 16 }}>
                  <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>Address</div>
                  <div style={{ 
                    wordBreak: "break-all", 
                    fontFamily: "monospace", 
                    fontSize: 14,
                    background: "#f8f9fb",
                    padding: 8,
                    borderRadius: 4,
                    border: "1px solid #e5e7eb"
                  }}>
                    {selected?.address}
                  </div>
                </div>
                <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
                  <button 
                    className="primary-btn" 
                    onClick={handleCopy}
                    style={{
                      padding: "8px 16px",
                      background: copied ? "#10b981" : "#3b82f6",
                      color: "white",
                      border: "none",
                      borderRadius: 6,
                      cursor: "pointer",
                      transition: "background-color 0.2s"
                    }}
                  >
                    {copied ? <FaCheck style={{ marginRight: 8 }} /> : <FaTimes style={{ marginRight: 8 }} />}
                    {copied ? "Copied" : "Copy Address"}
                  </button>
                </div>
              </div>
            </div>
          </>
        ) : (
          // Upload View for ALL gift cards
          <>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
              <button 
                className="back-button"
                onClick={handleBack}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontSize: 20,
                  color: "#6b7280",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  transition: "background-color 0.2s"
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = "#f3f4f6"}
                onMouseOut={(e) => e.target.style.backgroundColor = "transparent"}
              >
                <FaArrowLeft />
              </button>
              <h3 style={{ margin: 0, fontFamily: "DM Serif Display" }}>Upload {selected?.name} Gift Card</h3>
            </div>

            <div style={{ textAlign: "center" }}>
              {/* Message Display */}
              {message && (
                <div 
                  style={{ 
                    padding: 12,
                    marginBottom: 16,
                    borderRadius: 6,
                    background: successful ? "#d1fae5" : "#fee2e2",
                    color: successful ? "#065f46" : "#991b1b",
                    border: `1px solid ${successful ? "#a7f3d0" : "#fecaca"}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 8
                  }}
                >
                  {successful ? <FaCheck /> : <FaTimes />}
                  {message}
                </div>
              )}

              <div style={{ marginBottom: 24 }}>
                {SelectedIcon && (
                  <img 
                    src={SelectedIcon} 
                    alt={selected?.name} 
                    width={64} 
                    height={64} 
                    style={{ marginBottom: 16, borderRadius: 8 }} 
                  />
                )}
                <h4 style={{ fontFamily: "sono", marginBottom: 8, color: "#374151" }}>Upload Gift Card Images</h4>
                <p style={{ color: "#6b7280", fontFamily: "sono", fontSize: 14 }}>
                  Please upload clear images of the front and back of your {selected?.name} gift card.
                  Make sure all details are visible and readable.
                </p>
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 24 }}>
                {/* Front Image Upload */}
                <div>
                  <label style={{ display: "block", marginBottom: 8, fontWeight: 500, color: "#374151" }}>Front Side</label>
                  <div
                    style={{
                      border: "2px dashed #d1d5db",
                      borderRadius: 8,
                      padding: 20,
                      cursor: "pointer",
                      background: frontImage ? `url(${frontImage}) center/cover no-repeat` : "#f9fafb",
                      height: 140,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                      transition: "all 0.2s ease",
                      position: "relative",
                      overflow: "hidden"
                    }}
                    onMouseOver={(e) => e.target.style.borderColor = "#3b82f6"}
                    onMouseOut={(e) => e.target.style.borderColor = "#d1d5db"}
                    onClick={() => document.getElementById('front-upload').click()}
                  >
                    {frontImage ? (
                      <div style={{ 
                        textAlign: "center",
                        background: "rgba(255,255,255,0.9)",
                        padding: 8,
                        borderRadius: 4
                      }}>
                        <div style={{ color: "#10b981", fontWeight: 500, fontSize: 14 }}>✓ Front Image Uploaded</div>
                        <div style={{ fontSize: 12, color: "#6b7280" }}>Click to change</div>
                      </div>
                    ) : (
                      <>
                        <FaUpload style={{ color: "#9ca3af", marginBottom: 8, fontSize: 24 }} />
                        <div style={{ fontSize: 14, color: "#6b7280" }}>Click to upload front</div>
                        <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 4 }}>PNG, JPG up to 5MB</div>
                      </>
                    )}
                    <input
                      id="front-upload"
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={(e) => handleImageUpload(e, "front")}
                    />
                  </div>
                </div>

                {/* Back Image Upload */}
                <div>
                  <label style={{ display: "block", marginBottom: 8, fontWeight: 500, color: "#374151" }}>Back Side</label>
                  <div
                    style={{
                      border: "2px dashed #d1d5db",
                      borderRadius: 8,
                      padding: 20,
                      cursor: "pointer",
                      background: backImage ? `url(${backImage}) center/cover no-repeat` : "#f9fafb",
                      height: 140,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                      transition: "all 0.2s ease",
                      position: "relative",
                      overflow: "hidden"
                    }}
                    onMouseOver={(e) => e.target.style.borderColor = "#3b82f6"}
                    onMouseOut={(e) => e.target.style.borderColor = "#d1d5db"}
                    onClick={() => document.getElementById('back-upload').click()}
                  >
                    {backImage ? (
                      <div style={{ 
                        textAlign: "center",
                        background: "rgba(255,255,255,0.9)",
                        padding: 8,
                        borderRadius: 4
                      }}>
                        <div style={{ color: "#10b981", fontWeight: 500, fontSize: 14 }}>✓ Back Image Uploaded</div>
                        <div style={{ fontSize: 12, color: "#6b7280" }}>Click to change</div>
                      </div>
                    ) : (
                      <>
                        <FaUpload style={{ color: "#9ca3af", marginBottom: 8, fontSize: 24 }} />
                        <div style={{ fontSize: 14, color: "#6b7280" }}>Click to upload back</div>
                        <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 4 }}>PNG, JPG up to 5MB</div>
                      </>
                    )}
                    <input
                      id="back-upload"
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={(e) => handleImageUpload(e, "back")}
                    />
                  </div>
                </div>
              </div>

              <button 
                className="primary-btn" 
                onClick={handleSubmitGiftCard}
                disabled={!frontImage || !backImage || uploading}
                style={{ 
                  padding: "12px 24px",
                  background: (!frontImage || !backImage || uploading) ? "#9ca3af" : "#3b82f6",
                  color: "white",
                  border: "none",
                  borderRadius: 6,
                  cursor: (!frontImage || !backImage || uploading) ? "not-allowed" : "pointer",
                  fontSize: 16,
                  fontWeight: 500,
                  transition: "all 0.2s ease",
                  width: "100%",
                  maxWidth: 300
                }}
                onMouseOver={(e) => {
                  if (frontImage && backImage && !uploading) {
                    e.target.style.background = "#2563eb";
                  }
                }}
                onMouseOut={(e) => {
                  if (frontImage && backImage && !uploading) {
                    e.target.style.background = "#3b82f6";
                  }
                }}
              >
                {uploading ? (
                  <>⏳ Uploading...</>
                ) : (
                  <>📤 Submit {selected?.name} Gift Card</>
                )}
              </button>

              <div style={{ marginTop: 16, fontSize: 12, color: "#6b7280" }}>
                After submission, our team will verify your gift card and credit your account.
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DepositModal;